<template>
  <v-row no-gutters>
    <ComponentsFixedBar :minimized-side-menu="minimizedSideMenu" :title="$t('general.connect')"/>
    <template v-if="topLikings.length > 0">
      <v-col cols="2" class="my-1">
        <span class="kbDarkBlue--text">{{ $t('general.likes') }}</span>
        <span class="kbGrayText--text d-block"
              style="font-size: 12px; cursor: pointer; line-height: 1.1"
              @click="changeChipsShowMoreStatus('likings')"
              v-if="userLikings.length > 5">
          {{ chipsShowMoreStatus.likings ? $t('general.seeLess') : $t('general.seeMore') }}
        </span>
      </v-col>
      <v-col cols="10" class="my-1">
        <v-chip dark
                v-for="(like, index) in topLikings"
                :key="index"
                class="ma-1"
                :class="`${mainColor}--text`"
                :color="mainColor"
                outlined
                small
                pill>
          <v-avatar left
                    class="kbWhite--text"
                    :class="mainColor">
            {{ like.count || index + 1 }}
          </v-avatar>
          {{like.description}}
        </v-chip>
      </v-col>
    </template>

    <template v-if="topMusic.userTopTracks.length > 0">
      <v-col cols="2" class="my-1">
        <span class="kbDarkBlue--text">{{ $t('general.favoriteSongs') }}</span>
        <span class="kbGrayText--text d-block"
              style="font-size: 12px; cursor: pointer; line-height: 1.1"
              @click="changeChipsShowMoreStatus('userTopTracks')"
              v-if="spotifyInsights.userTopTracks.length > 5">
          {{ chipsShowMoreStatus.userTopTracks ? $t('general.seeLess') : $t('general.seeMore') }}
        </span>
      </v-col>
      <v-col cols="10" class="my-1">
        <v-chip dark
                v-for="(track, index) in topMusic.userTopTracks"
                :key="index"
                @click="goTo(track.external_urls.spotify)"
                class="ma-1"
                :class="`${mainColor}--text`"
                :color="mainColor"
                outlined
                small
                pill>
          <v-avatar left
                    class="kbWhite--text"
                    :class="mainColor">
            {{ index + 1 }}
          </v-avatar>
          <span>
            <strong>{{ track.name }} </strong>
            <span v-if="track.artists && Array.isArray(track.artists) && track.artists.length > 0">
                - {{track.artists[0].name}}
            </span>
          </span>
        </v-chip>
      </v-col>
    </template>

    <template v-if="topMusic.userTopGenres.length > 0">
      <v-col cols="2" class="my-1">
        <span class="kbDarkBlue--text">{{ $t('general.favoriteMusicalGenres') }}</span>
        <span class="kbGrayText--text d-block"
              style="font-size: 12px; cursor: pointer; line-height: 1.1"
              @click="changeChipsShowMoreStatus('userTopGenres')"
              v-if="spotifyInsights.userTopGenres.length > 5">
          {{ chipsShowMoreStatus.userTopGenres ? $t('general.seeLess') : $t('general.seeMore') }}
        </span>
      </v-col>
      <v-col cols="10" class="my-1">
        <v-chip dark
                v-for="(genre, index) in topMusic.userTopGenres"
                :key="index"
                class="ma-1"
                :class="`${mainColor}--text`"
                :color="mainColor"
                outlined
                small
                pill>
          <v-avatar left
                    class="kbWhite--text"
                    :class="mainColor">{{ index + 1 }}</v-avatar>
          {{ genre }}
        </v-chip>
      </v-col>
    </template>

    <template v-if="topMusic.userTopArtists.length > 0">
      <v-col cols="2" class="my-1">
        <span class="kbDarkBlue--text">{{ $t('general.favoriteArtists') }}</span>
        <span class="kbGrayText--text d-block"
              style="font-size: 12px; cursor: pointer; line-height: 1.1"
              @click="changeChipsShowMoreStatus('userTopArtists')"
              v-if="spotifyInsights.userTopArtists.length > 5">
          {{ chipsShowMoreStatus.userTopArtists ? $t('general.seeLess') : $t('general.seeMore') }}
        </span>
      </v-col>
      <v-col cols="10" class="my-1">
        <v-chip dark
                v-for="(artist, index) in topMusic.userTopArtists"
                :key="index"
                @click="goTo(artist.external_urls.spotify)"
                class="ma-1"
                :class="`${mainColor}--text`"
                :color="mainColor"
                outlined
                small
                pill>
          <v-avatar left
                    class="kbWhite--text"
                    :class="mainColor">
            {{ index + 1 }}
          </v-avatar>
          {{ artist.name }}
        </v-chip>
      </v-col>
    </template>

    <template v-if="topLikings.length === 0 &&
                    topMusic.userTopTracks.length === 0 &&
                    topMusic.userTopGenres.length === 0 &&
                    topMusic.userTopArtists.length === 0">
      <v-col cols="12" class="d-flex justify-center align-center" style="padding-top: 50px; height: 30vh">
        <div style="width: 100%">
          <div class="pb-2 text-center">
            <v-icon :color="mainColor" size="40px" class="mr-2">mdi-instagram</v-icon>
            <v-icon :color="mainColor" size="40px">mdi-spotify</v-icon>
          </div>
          <span class="kbGray--text text-center d-block"
                style="font-size: 18px; margin: 0 auto"
                :style="{ maxWidth: $vuetify.breakpoint.smAndDown ? '100%' : '70%' }">
            {{ $t('general.noInstagramSpotifyTags') }}
        </span>
        </div>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import notifications from '@/libs/notifications'
import ComponentsFixedBar from '@/pages/App/People/dialogs/ViewUser/ComponentsFixedBar'
export default {
  components: { ComponentsFixedBar },
  computed: {
    topLikings () {
      if (this.userLikings === 0) return []
      else if (this.userLikings.length > 0 && !this.chipsShowMoreStatus.likings) {
        return this.userLikings.slice(0, 5)
      } else {
        return this.userLikings
      }
    },
    topMusic () {
      if (Object.keys(this.spotifyInsights).length === 0) {
        return {
          userTopTracks: [],
          userTopGenres: [],
          userTopArtists: []
        }
      }
      let { userTopTracks, userTopGenres, userTopArtists } = this.spotifyInsights
      if (userTopTracks.length > 5 && !this.chipsShowMoreStatus.userTopTracks) {
        userTopTracks = userTopTracks.slice(0, 5)
      }
      if (userTopGenres.length > 5 && !this.chipsShowMoreStatus.userTopGenres) {
        userTopGenres = userTopGenres.slice(0, 5)
      }
      if (userTopArtists.length > 5 && !this.chipsShowMoreStatus.userTopArtists) {
        userTopArtists = userTopArtists.slice(0, 5)
      }
      return {
        userTopTracks,
        userTopGenres,
        userTopArtists
      }
    }
  },
  async created () {
    if (this.socialNetworksRegistered.instagram) await this.getUserLikings()
    if (this.socialNetworksRegistered.spotify) await this.getSpotifyInsights()
  },
  data () {
    return {
      chipsShowMoreStatus: {
        likings: false,
        userTopTracks: false,
        userTopGenres: false,
        userTopArtists: false,
        roles: false
      },
      spotifyInsights: {},
      userLikings: []
    }
  },
  methods: {
    changeChipsShowMoreStatus (key) {
      this.chipsShowMoreStatus[`${key}`] = !this.chipsShowMoreStatus[`${key}`]
    },
    async getUserLikings () {
      try {
        this.userLikings = []
        this.userLikings = await this.$store.dispatch('getUserLikings', this.userId)
      } catch (error) {
        notifications.error(error.message)
      }
    },
    async getSpotifyInsights () {
      try {
        this.spotifyInsights = await this.$store.dispatch('getUserSpotifyTops', this.userId) || {}
      } catch (e) {
        notifications.error(e.message)
      }
    },
    goTo (link) {
      window.open(link, '_blank')
    }
  },
  props: {
    mainColor: {
      type: String
    },
    minimizedSideMenu: {
      type: Boolean,
      required: true
    },
    socialNetworksRegistered: {
      type: Object
    },
    userId: {
      type: String
    }
  }
}
</script>
